import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom'
import { Header, Sidebar } from "../Layout";
import { getProjectsListForAddPartner } from "../../actions/projectActions";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { addNewPartner } from "../../actions/partnerActions";
import { useSelector, useDispatch } from "react-redux";
import { MEMBER, VALIDATE_EMAIL } from '../../constants/constants';

const AddNewPartner = function AddNewPartner() {
    const dispacth = useDispatch();
    const history = useHistory();
    const { projects } = useSelector(state => state.projectStore);
    const { user } = useSelector(state => state.auth);

    const formik = useFormik({
        initialValues: {
            invited_emails: "",

        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            invited_emails: Yup.string()
                .required("Partner is required")
                .test("multiple-email", "Email is not valid", (value) => {
                    value = value?.split(",");
                    let isValid = value?.filter((email) => !VALIDATE_EMAIL.test(email.trim()));
                    if (isValid?.length) return false;
                    else return true;
                }),
            project_id: Yup.string().required('Project is required')
        }),
        onSubmit: (value, { resetForm }) => {
            dispacth(addNewPartner(value));
            resetForm();
        },
    });
    useEffect(() => {
        if (user.userType === MEMBER) history.push('/')
        dispacth(getProjectsListForAddPartner());
    }, [user, dispacth, history])

    const ProjectList = () => {
        if (!projects || !projects?.length) return <></>;
        return projects.map((project) => <option key={`key_${project.id}`} value={project.id} label={project.title}></option>)
    }
    return (
        <>
            <Header />
            <Sidebar />
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Invite Partner</h2>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                                <li className="breadcrumb-item active">Project / Invite Partner</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                            <h3>Add New Partner</h3>
                        </div>
                    </div>
                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="card card-radius">
                                <div className="header card-header custum-bg-warning rounded">
                                    <h2 className="text-white">Invite to join project</h2>
                                </div>
                                <form onSubmit={formik.handleSubmit}>
                                    <div className="body card-body-shadow">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                <div className="form-group">
                                                    <label htmlFor="project_id" className="control-label">Project<span className='text-danger'>*</span></label>
                                                    <select className="form-control" name='project_id'  {...formik.getFieldProps('project_id')} >
                                                        <option>Select</option>
                                                        <ProjectList />
                                                    </select>
                                                    {formik.touched.project_id && formik.errors.project_id ? (
                                                        <div className="text-danger pt-2">{formik.errors.project_id}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                <div className="form-group">
                                                    <label htmlFor="partner_email" className="control-label">Add Partner<span className='text-danger'>*</span></label>
                                                    <input type="text" name={'invited_emails'} id="partner_email" className="form-control"  {...formik.getFieldProps('invited_emails')} placeholder="Please Enter Emails "/>
                                                    {formik.touched.invited_emails && formik.errors.invited_emails ? (
                                                        <div className="text-danger pt-2">{formik.errors.invited_emails}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className='row'>
                                            <div className="col-lg-12 col-md-12 col-sm-12">
                                                <div className="form-group">
                                                    <label htmlFor="partner_email" className="control-label">Add Partner<span className='text-danger'>*</span></label>
                                                    <input type="text" name={'invited_emails'} id="partner_email" className="form-control"  {...formik.getFieldProps('invited_emails')} placeholder="Please Enter Emails "/>
                                                    {formik.touched.invited_emails && formik.errors.invited_emails ? (
                                                        <div className="text-danger pt-2">{formik.errors.invited_emails}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                    <div className='row px-2 pb-3'>
                                        <div className='col-md-4 col-lg-6 col-sm-6'>
                                            <button type='button' onClick={formik.handleReset} className='btn btn-outline-danger'><i className='icon-close'></i> Discard</button>
                                        </div>
                                        <div className='col-md-4 col-lg-6 col-sm-6  text-right'>
                                            <button className='btn button'>Send invitation</button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddNewPartner
